<template>
  <div>
    <div class="my-16 flex flex-row items-center">
      <div class="grow">
        <Price
          v-if="product && selectedOffer"
          :mobile-plan="selectedMobilePlan"
          :price
          :product
          :selectedOffer
        />
      </div>

      <RevButton
        v-if="selectedOffer"
        class="mood-tangaroa"
        data-id="product-page-buy-button-mobile"
        data-qa="product-page-buy-button-mobile"
        variant="primary"
        @click="onAddToCart"
      >
        {{ i18n(translations.addToCart) }}
      </RevButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
// fixme: duplicated code due to Japan improved PP
import type { Price as PriceType } from '@backmarket/http-api'
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-b2c-services/mobile-plan/types/mobile-plan-offers'
import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import type { Rating } from '@backmarket/http-api/src/api-specs-reviews/types/rating'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import translations from '~/scopes/product/components/Title/TitleDesktop.translations'
import { useAddToCart } from '~/scopes/product/composables/useAddToCart'
import { useProductTracking } from '~/scopes/product/composables/useProductTracking'

import Price from '../Price/Price.vue'

const props = withDefaults(
  defineProps<{
    selectedOffer?: GetPickersResponse['selectedOffer'] | null
    product: GetProductResponse
    price: PriceType
    rating?: Rating | null
    tracking: ReturnType<typeof useProductTracking>
    selectedMobilePlan?: MobilePlanOffer
  }>(),
  {
    selectedOffer: null,
    rating: null,
    selectedMobilePlan: undefined,
  },
)

const { addToCart } = useAddToCart()
const i18n = useI18n()

function onAddToCart() {
  if (props.selectedOffer) {
    addToCart({
      listingId: props.selectedOffer.offerLegacyId,
      listingPublicId: props.selectedOffer.offerId,
      tracking: {
        ...props.tracking.product.value,
        list: 'product_page',
        campaign_id: props.selectedOffer.campaignId,
        population_id: props.selectedOffer.populationId,
      },
      partnerPromoCodes: props.product.includedServiceOffers.partnerPromoCodes,
      isTradeInEligible: props.product.isTradeInEligible,
    })
  }
}
</script>
